<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="applyDialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="500px"
            center>
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">添加常见问题</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <el-form class="form" :model="ruleForm" :rules="rules" ref="ruleForm" labelWidth="auto">
                <el-form-item prop="title" label="问题">
                    <el-input v-model="ruleForm.title" placeholder="请输入问题">
                    </el-input>
                </el-form-item>

                <el-form-item prop="keyWords" label="关键词">
                    <el-tag
                            :key="tag"
                            v-for="tag in ruleForm.keyWords"
                            closable
                            :disable-transitions="false"
                            @close="handleClose(tag)">
                        {{tag}}
                    </el-tag>
                    <el-input
                            class="input-new-tag"
                            v-if="inputVisible"
                            v-model="inputValue"
                            ref="saveTagInput"
                            size="small"
                            @keyup.enter.native="handleInputConfirm"
                            @blur="handleInputConfirm"
                    >
                    </el-input>
                    <el-button v-else class="button-new-tag" size="small" @click="showInput">添加</el-button>
                </el-form-item>

                <el-form-item prop="content" label="答案">
                    <el-input v-model="ruleForm.content" placeholder="请输入服务需求留言" type="textarea" resize="none"
                              :autosize="{ minRows: 6, maxRows: 6 }">
                    </el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-operate flex align-center justify-center">
                <el-button class="operate black" @click="cancel">取消</el-button>
                <el-button class="operate" :loading="loading" @click="submitForm('ruleForm')">
                    保存
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import {addQuestion} from '@/api/branch'

    export default {
        name: "AddQuestionDialog",
        props: {
            applyDialogVisible: {
                type: Boolean,
                default: false
            },
            id: { //详情ID
                type: Number,
            },
            info: {
                type: Object
            }
        },
        data() {
            return {
                loading: false,
                ruleForm: {
                    title: '',
                    keyWords: [],
                    content: '',
                },
                rules: {
                    title: [
                        {required: true, message: '请输入问题', trigger: 'blur'}
                    ],
                    keyWords: [
                        {type: 'array', required: true, message: '请添加关键词', trigger: 'blur'}
                    ],
                    content: [
                        {required: true, message: '请输入答案', trigger: 'blur'},
                    ]
                },
                inputVisible: false,
                inputValue: ''
            }
        },
        created() {
        },
        methods: {
            handleClose(tag) {
                this.ruleForm.keyWords.splice(this.ruleForm.keyWords.indexOf(tag), 1);
            },

            showInput() {
                this.inputVisible = true;
                this.$nextTick(() => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },
            handleInputConfirm() {
                let inputValue = this.inputValue;
                if (inputValue) {
                    this.ruleForm.keyWords.push(inputValue);
                }
                this.inputVisible = false;
                this.inputValue = '';
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addQuestion();
                    }
                });
            },
            async addQuestion() {
                this.loading = true
                let _data = await addQuestion(this.id, this.ruleForm.title, this.ruleForm.content, this.ruleForm.keyWords.join('/'))
                this.loading = false
                if (_data.status === 200) {
                    this.clearContent()
                    this.$message.success(_data.msg)
                    this.$emit('watchState', true)
                }
            },
            cancel() {
                this.clearContent()
                this.$emit('watchState', false)
            },
            clearContent(){
                this.$refs.ruleForm.resetFields()
            },
        },
        watch: {
            info() {
                if (this.info) {
                    this.ruleForm = {
                        title: this.info.title,
                        keyWords: this.info.key_word,
                        content: this.info.content,
                    }
                } else {
                    this.ruleForm = {
                        title: '',
                        keyWords: [],
                        content: '',
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .el-tag + .el-tag {
        margin-left: 10px;
    }

    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }

    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }

    .detail-dialog-container {
        .dialog-container {
            .dialog-header {
                height: 55px;
                .dialog-title {
                    font-size: 18px;
                    font-weight: bold;
                    color: #0a2240;
                    text-align: center;
                }
                .dialog-close {
                    font-size: 21px;
                    color: #0a2240;
                    font-weight: bold;
                    cursor: pointer;
                }
            }
            .dialog-content {
                padding: 40px 80px;
                height: 605px;
                .title {
                    font-size: 24px;
                    font-weight: bold;
                    color: #0a2240;
                    text-align: center;
                }
                .content {
                    margin-top: 38px;
                    overflow-y: scroll;
                    &::-webkit-scrollbar {
                        display: none
                    }
                }
                .time {
                    font-size: 16px;
                    color: #0a2240;
                    margin-top: 16px;
                }
            }
            .dialog-operate {
                margin-top: 20px;
                .operate {
                    width: 200px;
                    height: 40px;
                    border-radius: 20px;
                    font-size: 16px;
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#ff9600, #ff9600);
                    background-blend-mode: normal, normal;
                    color: #ffffff;
                    &.black {
                        background: #0a2240 none;
                    }
                }
                .operate + .operate {
                    margin-left: 80px;
                }
            }
            .dialog-footer {
                height: 40px;
                background-color: #e7eff9;
                padding: 0 20px;
                border-radius: 0 0 10px 10px;
                .content {
                    font-size: 16px;
                    color: #8b9fbe;
                }
            }
        }
    }
</style>